import TechnicalPage from "./technical.page"

export default TechnicalPage;
